export default "__VITE_ASSET__DtMh5TGT__"